import useStyles from './useStyles'

function TableHeader() {
  const classes = useStyles()

  return (
    <thead className={classes.row}>
      <tr>
        <th className={classes.headName}>Parámetro</th>
        <th className={classes.headValue}>Tipo de valor</th>
        <th className={classes.headValue}>Valor</th>
        <th className={classes.headKebab}></th>
      </tr>
    </thead>
  )
}

export default TableHeader
